

import { Component, Mixins, Watch, Prop } from "vue-property-decorator";

import GlobalMixin from "@/mixins/global";
import Flag from "@/components/Flags/Flag.vue";
import DropdownList from "@/components/Dropdown/DropdownList.vue";
import { setFieldModel } from "@/views/Counterparties/models";
import IBStaticBadge from "@/components/IBBadge/IBStaticBadge.vue";
import IBCircleCheckbox from "@/components/IBCheckbox/IBCircleCheckbox.vue";
import FormOnChange from "@/components/Form/mixins/FormOnChange";

@Component({
	components: {
		DropdownList,
		Flag,
		IBStaticBadge,
		IBCircleCheckbox,
	}
})
export default class Dropdown extends Mixins(
	GlobalMixin,
	FormOnChange
) {
	@Prop({ default: null })
	readonly value!: any;

	@Prop({ type: String, default: '' })
	readonly title!: string;

	@Prop({ type: Boolean, default: false })
	readonly isTitleBtnShow!: boolean;

	@Prop({ type: String, default: '' })
	readonly img!: string;

	@Prop({ type: String, default: '' })
	readonly flag!: string;

	@Prop({ type: String, default: '' })
	readonly className!: string;

	@Prop({ type: String, default: '' })
	readonly btnClassName!: string;

	@Prop({ type: String, default: '' })
	readonly newText!: string;

	@Prop({ type: Boolean, default: false })
	readonly isActive!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly clearable!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly noClearable!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly showCount!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly usePropsAsTitle!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly showCheckIcon!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly disabled!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly checkbox!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly isDropdown!: boolean;

	@Prop({ type: Boolean, default: true })
	readonly namePropVisibility!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly isDatePicker!: boolean;

	@Prop({ type: Array, default: () => [] })
	readonly chipsDropdown!: any[];

	@Prop({ type: Boolean, default: false })
	readonly emitIndex!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly valid!: boolean;

	@Prop({ type: Array, default: () => [] })
	readonly fields!: any[];

  @Prop({ type: Boolean, default: false })
  readonly useSelectedText!: boolean;

	isBtnActive: boolean = false;

	isPosition: boolean = false;

	modelUpdating: boolean = false;

	selectedDropdownText: string = "";

	filterDropdown: any = {
		name: '',
		props: '',
		count: 0,
	}

	created() {
		this.model && this.setDropdownItemFromValue();
	}

	radioActive(value: Event) {
		this.$emit("click", value);

		if (this.isDropdown) {
			window.addEventListener("click", (e: Event) => {
				if (e.target != this.$refs["btn"]) {
					if (this.fields.length) {
						if (!(e.target as any)?.closest('.dropdown'))
							//@ts-ignore
							this.isBtnActive = false;
					} else {
							//@ts-ignore
						this.isBtnActive = false;
					}
				}
			});

			let dropdown: Array<HTMLElement> = [].slice.call(document.querySelectorAll(".dropdown"));
			let vm: any = this;

			if (dropdown) {
				dropdown.forEach((btn: HTMLElement) => {
					btn.addEventListener("click", function () {
						let ul = this.children[1];
						if (ul) {
							let right: boolean = (window.innerWidth - ul.getBoundingClientRect().x - 465) < 50;
							let left: boolean = ul.getBoundingClientRect().x < 115;
							if (right) {
								vm.isPosition = true;
							}
							if (left) {
								vm.isPosition = false;
							}
						}
					});
				});
			}
		} else if (this.checkbox) {
			this.model = !this.model;
		}
			//@ts-ignore
		this.isBtnActive = !this.isBtnActive;
		if (!this.isActive) {
				//@ts-ignore
			this.isBtnActive = true;
		}
	}

	dropdownItem(index: number, value: boolean) {
		this.model = value;
		this.$emit("changeDropdown", this.emitIndex ? index : value);
			//@ts-ignore
		this.filterDropdown = this.chipsDropdown.find((i, idx) => idx === index) || {};
			//@ts-ignore
		this.selectedDropdownText = this.usePropsAsTitle
			//@ts-ignore
			? this.filterDropdown.props
				//@ts-ignore
			: this.filterDropdown.name;
	}

	setDropdownItemFromValue() {
		if (!this.model) return this.resetSelected();

		for (let i = 0; i < this.chipsDropdown.length; i++) {
			if ((this as any).chipsDropdown[i].name === this.model) {
				this.dropdownItem(i, this.model);

				break;
			}
		}
	}

	resetSelected() {
		this.$emit("changeDropdown", "reset");
			//@ts-ignore
		this.selectedDropdownText = "";
		this.clearFieldModels();
	}

	clearFieldModels() {
		(this.fields as any).forEach(setFieldModel);
	}

	getListItemClassName(item: any) {
		const changeText = this.usePropsAsTitle
			? item.props
			: item.name;

		return (item.className ? item.className : '') +
			' ' +
			this.className +
			(this.changeText === changeText ? ' active' : '');
	}

	get changeText(): string {
		return this.newText ? this.newText : this.selectedDropdownText;
	}

	get titleIfNamePropHidden(): string {
		try {
			return (<any>this.chipsDropdown.find((i: any) =>
          this.useSelectedText ? this.selectedDropdownText === i.name : this.newText === i.name)).nameText;
		} catch { }

		return '';
	}


	get model(): boolean {
		return (this as any).value;
	}

	set model(value) {
		(this as any).modelUpdating = true;

		(this as any).$emit('input', value);

		(this as any).callOnChange(value);

		(this as any).$nextTick(() => (this as any).modelUpdating = false);
	}

	get totalCount(): any[] {
		return this.chipsDropdown.reduce((a, b: any) => a + (b.noSummarize ? 0 : b.count), 0);
	}

	get count(): number {
		return this.value
			//@ts-ignore
			? ((this.model && this.filterDropdown?.count) || 0)
			: this.totalCount;
	}

	@Watch('isActive')
	isActiveChange() {
			//@ts-ignore
		this.isBtnActive = this.isActive;
	}

	@Watch('newText')
	newTextChange() {
		if (!this.newText) this.resetSelected();
	}

	@Watch('model')
	modelChange() {
		this.modelUpdating || this.setDropdownItemFromValue();
	}
}

